module.exports = __webpack_public_path__ + "static/media/live-chat.3bdd9471.svg";